<script setup lang="ts">
import { computed } from 'vue';
import { loadingMessages } from '../../messages';

const props = withDefaults(
  defineProps<{
    text?: string;
    fill?: boolean;
    size?: string;
  }>(),
  {
    text: undefined,
    fill: false,
    size: '3rem',
  },
);

const label = computed(() => props.text ?? loadingMessages.loading);
const spinnerStyle = computed(() => ({
  width: props.size,
  height: props.size,
}));
</script>

<template>
  <div
    class="itp-loading d-flex flex-column align-items-center justify-content-center"
    :class="{
      'flex-grow-1': fill,
    }"
    role="status"
    aria-live="polite"
  >
    <div class="spinner-border text-primary mb-3" :style="spinnerStyle">
      <span class="visually-hidden">{{ label }}</span>
    </div>
    <h5 class="itp-loading__text text-muted mb-0">{{ label }}</h5>
  </div>
</template>
